import { createFileRoute } from "@tanstack/react-router";
import NicaHoy from "@/pages/NicaHoy";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/tiempos-nica-hoy")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 0),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
    const title = `Tiempos Nica Hoy ${s.dateLabel}${s.nica ? `: ${s.nica}` : ""} | Diaria Loto Nicaragua`;
    const description = `¿Qué salió en Tiempos Nica Hoy? Resultados de la Loto Diaria de Nicaragua ${s.dateLabel}: ${s.nica || "sorteos de 11am, 3pm y 9pm (6pm fines de semana)"}. Con MultiX y dígito final.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/tiempos-nica-hoy" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/tiempos-nica-hoy" }],
    };
  },
  component: NicaHoy,
});
